<template>
    <div class="row justify-content-center">
        <div v-if="isReady" class="col-11 col-sm-6 col-md-5 card">
            <div class="text-center font-weight-bold mt-2">
               "{{ getSale.company.name }}"
            </div>
            <div class="mt-3">
                {{ $t('printView.receipt') }} <span class="font-weight-bold">{{ getSale.id }}</span>
            </div>
            <div>
                {{ $t('date') }}: <span class="font-weight-bold">{{ dateTimeFormat(getSale.createdAt) }}</span>
            </div>
            <div>
                {{ $t('employee.cashier') }}:
                <span class="font-weight-bold">
                {{ getSale.employee.givenName + ' ' + getSale.employee.familyName }}
                </span>
            </div>
            <div>
                {{ $t('company.telephone') }}:
                <span class="font-weight-bold">{{ getSale.company.people[0].telephone }}</span>
            </div>
            <hr>
            <div v-for="saleProduct in getSale.saleProducts" :key="saleProduct.id" class="d-flex justify-content-between">
                <span class="font-weight-bold">{{ saleProduct.product.name }}</span>
                <span>{{ showCurrencyByIdWithoutSymbol(saleProduct.product.sellingPriceCurrency.id, saleProduct.product.sellingPrice) }} x
                {{ parseFloat(saleProduct.amount) }} {{ showUnitOfMeasure(saleProduct.product.unitOfMeasure) }} = {{ showCurrencyById(saleProduct.product.sellingPriceCurrency.id, saleProduct.product.sellingPrice * saleProduct.amount) }}</span>
            </div>
            <hr>
            <div class="d-flex justify-content-between">
                {{ $t('printView.totalSum') }}: <span class="font-weight-bold">{{ showCurrencyById(getSale.currency.id, getSale.totalPrice) }}</span>
            </div>
            <div class="d-flex justify-content-between">
                {{ $t('payedAmount') }}: <span class="font-weight-bold">{{ showCurrencyById(getSale.currency.id, getSale.payedAmount) }}</span>
            </div>
            <div class="d-flex justify-content-between" v-if="parseFloat(getSale.oddMoney) > 0">
                {{ $t('sale.oddMoney') }}: <span class="font-weight-bold">{{ showCurrencyById(getSale.currency.id, getSale.oddMoney) }}</span>
            </div>
            <div class="d-flex justify-content-between">
                {{ $t('payType') }}: <span class="font-weight-bold">{{ showPayType(getSale) }}</span>
            </div>
            <hr v-if="getSale.company.legalAddress">
            <div v-if="getSale.company.legalAddress">
                {{ $t('companyRequisites.legalAddress') }}: <span class="font-weight-bold">{{ getSale.company.legalAddress }}</span>
            </div>
            <div v-if="getSale.company.physicalAddress">
                {{ $t('companyRequisites.physicalAddress') }}: <span class="font-weight-bold">{{ getSale.company.physicalAddress }}</span>
            </div>
            <hr>
            <div style="font-size: 12px; font-weight: bold">
                {{ getInfo }}
            </div>
            <div class="text-center">
                <span class="font-weight-bold"> {{ $t('sale.thankPurchase') }}!!! </span>
            </div>
            <div class="d-flex justify-content-center">
                <b-button @click="printReceipt" class="print">
                    {{ $t('print') }}
                </b-button>
            </div>
            <div class="d-flex justify-content-center">
                <b-button @click="toSale" class="sale">
                    {{ $t('sale.newSale') }}
                </b-button>
            </div>
        </div>
    </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import dateFormattingMixin from "@/mixin/dateFormattingMixin";
import currencyFormatMixin from "@/mixin/currencyFormatMixin";

export default {
    name: "AfterSale",
    mixins: [dateFormattingMixin, currencyFormatMixin],
    data() {
        return {
            isReady: false
        }
    },
    computed: {
        ...mapGetters(['getSale', 'getInfo'])
    },
    methods: {
        ...mapActions(['fetchSale']),
        showPayType(sale) {
            if (sale.cash > 0) {
                return this.$t('statistics.categories.cash')
            } else if (sale.bankCard > 0) {
                return this.$t('statistics.categories.bankCard')
            } else if (sale.moneyTransfer > 0) {
                return this.$t('statistics.categories.moneyTransfer')
            } else {
                return this.$t('debt')
            }
        },
        printReceipt() {
            this.$i18nHelper.toUrl('sales/transactions/' + this.$route.params.id + '/check-print')
        },
        toSale() {
            this.$i18nHelper.toUrl('sales/sale')
        }
    },
    mounted() {
        this.$root.showOverlay = true

        this.fetchSale(this.$route.params.id)
            .then(() => {
                this.isReady = true
                console.log(this.getSale)
            })
            .finally(() => {
                this.$root.showOverlay = false
                if (this.getSale.saleProducts.length >= 5) {
                    window.scrollTo(0, 0)
                } else {
                    window.scrollTo(0, 5000)
                }
            })
    },
}
</script>

<style scoped>

.print, .sale {
    margin-top: 25px;
    width: 75%;
    font-size: 18px;
    font-weight: 600;
    border-radius: 10px;
    outline: none;
    box-shadow: none;
}

.print {
    background-color: #6f42c1;
}

.sale {
    background-color: #0A8C1A;
}

.card {
    padding: 20px;
    box-shadow: 2px 4px 4px 2px rgba(0, 0, 0, .15);
}

</style>
